import {Policy} from '../Policy'
import {Plan} from '../Plan'
import {EmailData} from './EmailData'

export type IndividualRenewalEmailData = EmailData & {
    policy: Policy
    plan: Plan
    approvedClaims: number
}
